module.exports = __webpack_public_path__ + "static/media/pink-gold-confetti.64da6932.jpg";